var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent is-vertical" }, [
    _vm.quotes
      ? _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _c("orm-batch-statistics", {
              attrs: {
                count: _vm.quotes ? _vm.quotes.length : 0,
                alr: _vm.alr,
                "alr-lower-threshold": _vm.innerValue.alrLowerThreshold,
                "alr-upper-threshold": _vm.innerValue.alrUpperThreshold,
                "average-labour-units": _vm.averageLabourUnits,
                "average-labour-values": _vm.averageLabourValues,
                "average-non-labour-values": _vm.averageNonLabourValues,
                "average-total-ex-gst": _vm.averageTotalExGst,
                "adjusted-total": _vm.adjustedTotal,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("p", { staticClass: "title" }, [_vm._v("In Scope")]),
            _c("div", { staticClass: "field is-narrow has-addons" }, [
              _c("div", { staticClass: "control has-icons-left" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.availableQuoteQuery,
                      expression: "availableQuoteQuery",
                    },
                  ],
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder: "Start typing to search",
                  },
                  domProps: { value: _vm.availableQuoteQuery },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.availableQuoteQuery = $event.target.value
                    },
                  },
                }),
                _vm._m(0),
              ]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary is-outlined tooltip",
                    attrs: { "data-tooltip": "Reset search" },
                    on: {
                      click: function ($event) {
                        _vm.availableQuoteQuery = ""
                      },
                    },
                  },
                  [_vm._m(1)]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "column is-narrow" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(2),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedAvailableBatchId,
                            expression: "selectedAvailableBatchId",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedAvailableBatchId = $event.target
                              .multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          { domProps: { value: _vm.guid.empty() } },
                          [_vm._v("Not Batched")]
                        ),
                        _vm._l(_vm.activeBatchIds, function (activeBatchId) {
                          return _c(
                            "option",
                            {
                              key: activeBatchId.value,
                              domProps: { value: activeBatchId.key },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(`Batch No. ${activeBatchId.value}`) +
                                  " "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm.availableBatch
          ? _c("orm-batch-statistics", {
              attrs: {
                count: _vm.availableQuotes ? _vm.availableQuotes.length : 0,
                alr: _vm.availableAlr,
                "alr-lower-threshold": _vm.availableBatch.alrLowerThreshold,
                "alr-upper-threshold": _vm.availableBatch.alrUpperThreshold,
                "average-labour-units": _vm.availableAverageLabourUnits,
                "average-labour-values": _vm.availableAverageLabourValues,
                "average-non-labour-values":
                  _vm.availableAverageNonLabourValues,
                "average-total-ex-gst": _vm.availableAverageTotalExGst,
                "adjusted-total": _vm.availableAdjustedTotal,
              },
            })
          : _vm._e(),
        _vm.availableBatch
          ? _c("div", { staticClass: "is-divider" })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c(
              "bulma-table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                attrs: {
                  columns: _vm.availableQuoteColumns,
                  "page-index": _vm.availableQuoteFilter.pageIndex,
                  "page-size": _vm.availableQuoteFilter.pageSize,
                  "total-rows": _vm.availableQuoteTotalRows,
                  "is-loading": _vm.isAvailableQuoteTableLoading,
                  "sort-column": _vm.availableQuoteFilter.sortColumn,
                  "sort-order": _vm.availableQuoteFilter.sortOrder,
                  draggable: false,
                  "show-pagination": false,
                },
                on: {
                  pageChanged: _vm.onAvailableQuotePageChange,
                  sort: _vm.onAvailableQuoteSort,
                },
              },
              [
                _vm._l(_vm.filteredAvailableQuotes, function (quote, index) {
                  return _c(
                    "tr",
                    {
                      key: quote.quoteId,
                      on: {
                        click: function ($event) {
                          return _vm.highlightSelectedAvailableQuote(
                            index,
                            $event
                          )
                        },
                      },
                    },
                    [
                      _c("td", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.viewQuote(quote.quoteId)
                              },
                            },
                          },
                          [_vm._v(_vm._s(quote.quoteNo))]
                        ),
                      ]),
                      _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                      _c("td", [_vm._v(_vm._s(quote.rego))]),
                      _c("td", [_vm._v(_vm._s(quote.customerName))]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.excess,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatNumber(
                              quote.labourHour,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.rate,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.labourTotal,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.partTotal,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.subletTotal,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.miscTotal,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              quote.totalExGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c(
                        "td",
                        {
                          staticClass:
                            "has-vertical-middle has-text-centered is-content-width",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-success is-small is-inverted tooltip is-tooltip-topright",
                              attrs: { "data-tooltip": "Add to batch" },
                              on: {
                                click: function ($event) {
                                  return _vm.addToBatch(index, quote)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-medium" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-plus mdi-24px",
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _c("template", { slot: "empty" }, [
                  _c("section", { staticClass: "section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "content has-text-grey has-text-centered",
                      },
                      [
                        _c("span", { attrs: { icon: "icon is-large" } }, [
                          _c("i", {
                            staticClass: "mdi mdi-48px mdi-emoticon-sad",
                          }),
                        ]),
                        _c("p", [_vm._v("Nothing")]),
                      ]
                    ),
                  ]),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("article", { staticClass: "tile is-child box" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Out Of Scope")]),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c(
            "bulma-table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
              attrs: {
                columns: _vm.availableQuoteColumns,
                "page-index": _vm.outOfScopeQuoteFilter.pageIndex,
                "page-size": _vm.outOfScopeQuoteFilter.pageSize,
                "total-rows": _vm.outOfScopeQuoteTotalRows,
                "is-loading": _vm.isOutOfScopQuoteTableLoading,
                "sort-column": _vm.outOfScopeQuoteFilter.sortColumn,
                "sort-order": _vm.outOfScopeQuoteFilter.sortOrder,
                draggable: false,
                "show-pagination": false,
              },
              on: {
                pageChanged: _vm.onAvailableQuotePageChange,
                sort: _vm.onAvailableQuoteSort,
              },
            },
            [
              _vm._l(_vm.outOfScopeQuotes, function (quote, index) {
                return _c(
                  "tr",
                  {
                    key: quote.quoteId,
                    on: {
                      click: function ($event) {
                        return _vm.highlightSelectedAvailableQuote(
                          index,
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.viewQuote(quote.quoteId)
                            },
                          },
                        },
                        [_vm._v(_vm._s(quote.quoteNo))]
                      ),
                    ]),
                    _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                    _c("td", [_vm._v(_vm._s(quote.rego))]),
                    _c("td", [_vm._v(_vm._s(quote.customerName))]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.excess,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            quote.labourHour,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.rate,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.labourTotal,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.partTotal,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.subletTotal,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.miscTotal,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            quote.totalExGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("td", {
                      staticClass:
                        "has-vertical-middle has-text-centered is-content-width",
                    }),
                  ]
                )
              }),
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c("span", { attrs: { icon: "icon is-large" } }, [
                        _c("i", {
                          staticClass: "mdi mdi-48px mdi-emoticon-sad",
                        }),
                      ]),
                      _c("p", [_vm._v("Nothing")]),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Source")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }